export interface Crumb {
  name: string;
  path: string;
  aria?: string;
}

const originalNameAndNewNameReplaceMap: { [key: string]: string } = {
  Mobilabonnemang: 'Abonnemang',
};

/**
 * Initiates the breadcrumbs list with a default crumb.
 *
 * @returns {Crumb[]} The initial list of breadcrumbs.
 */
export const initiateBreadcrumbsList = (): Crumb[] => {
  const crumbs: Crumb[] = [];

  crumbs.push({
    name: 'hem',
    path: 'https://www.halebop.se',
    aria: 'Startsidan',
  });

  return crumbs;
};

/**
 * Builds a list of breadcrumbs from the given route path.
 *
 * @param {string} routeFullPath - The full path of the current route.
 * @returns {Crumb[]} The list of breadcrumbs derived from the path.
 */
export const buildBreadcrumbsListFromPath = (
  routeFullPath: string,
): Crumb[] => {
  const withoutFirstSlash =
    (routeFullPath &&
      routeFullPath.startsWith('/') &&
      routeFullPath.substring(1)) ||
    routeFullPath;

  const params = withoutFirstSlash.split('/');

  let path = '';

  return params.map((param: string) => {
    path = `${path}/${param}`;
    //TODO: detta är bara tillfälligt, vi kommer behöva komma på nått annat sätt att hantera detta på.
    // Detta kommer ex. skapa problem om man döper innehållssidor med åäö.
    if (param === 'tillbehor') {
      param = param?.replaceAll('o', 'ö');
    }

    const newCrumb: Crumb = {
      name: param?.replaceAll('-', ' '),
      path: path,
    };
    return newCrumb;
  });
};

/**
 * Sets the name of the last crumb in the list to the specified page name.
 *
 * @param {string} pageName - The new name to set on the last crumb.
 * @param {Crumb[]} crumbs - The list of breadcrumbs.
 * @returns {Crumb[]} The updated list of breadcrumbs.
 */
export const setPageNameOnLastCrumb = (
  pageName: string,
  crumbs: Crumb[],
): Crumb[] => {
  const newCrumbs = crumbs.slice();
  newCrumbs[newCrumbs.length - 1].name = pageName;
  return newCrumbs;
};

/**
 * Capitalizes the name of each crumb in the list.
 *
 * @param {Crumb[]} crumbs - The list of breadcrumbs.
 * @returns {Crumb[]} The list of breadcrumbs with capitalized names.
 */
export const capitalizeCrumbs = (crumbs: Crumb[]): Crumb[] => {
  const newCrumbs = crumbs.slice();

  for (const c of newCrumbs) {
    c.name = capitalizeFirstCharacterInString(c.name);
  }

  return newCrumbs;
};

/**
 * Removes the crumb with path '/shop' from the list without mutating the original array.
 *
 * @param {Crumb[]} crumbs - The list of breadcrumbs.
 * @returns {Crumb[]} The list of breadcrumbs without the '/shop' crumb.
 */
export const cleanOutShop = (crumbs: Crumb[]): Crumb[] => {
  // Remove all crumbs with path '/shop' or '/deals' without mutating the original array
  return crumbs.filter(
    (crumb) => crumb.path !== '/shop' && crumb.path !== '/deals',
  );
};

/**
 * Replaces names of crumbs with more presentable names based on a predefined map.
 *
 * @param {Crumb[]} crumbs - The list of breadcrumbs.
 * @returns {Crumb[]} The list of breadcrumbs with replaced names.
 */
export const replaceNamesWithPresentableOnes = (crumbs: Crumb[]): Crumb[] => {
  const newCrumbs = crumbs.slice();

  for (const c of newCrumbs) {
    if (originalNameAndNewNameReplaceMap[c.name]) {
      c.name = originalNameAndNewNameReplaceMap[c.name];
    }
  }

  return newCrumbs;
};
